import { css } from '@emotion/react';

export const ScrollBarStyle = () => css`
	::-webkit-scrollbar {
		width: 16px;
	}

	/* 4px scroll thumb. 10px margin from right margin */
	::-webkit-scrollbar-track {
		box-shadow: inset 0 0 14px 14px transparent;
		border: solid 4px transparent;
	}

	::-webkit-scrollbar-thumb {
		box-shadow: inset 0 0 14px 14px #9a9cb1;
		border: solid 4px transparent;
		border-radius: 14px;
	}

	::-webkit-scrollbar-button {
		display: none;
	}
`;
